export default {
  TEXT: 'sms',
  EMAIL: 'email',
  RECORD_NUMBER: 'mrn',
}
